import React from 'react'
import PropTypes from 'prop-types'
import DropIcon from './../general/icons/DropIcon'
import ButtonContainer from './../general/buttons/ButtonContainer'
import './../ui.style.scss'

class BucketListCell extends React.Component {
  render () {
    const { isSelected, status, shortId, bucketName, bucketType, onClick, onBucketAdd, isEnabled, isArchived } = this.props
    return (
      <div className={`bucket-list-cell ${status ? status.toLowerCase() : ''} ${isSelected ? 'active' : ''}`} onClick={onClick}>
        <div className='cell'>
          <div className='cell-left'>
            <p> {bucketName} </p>
            <p> {bucketType} </p>
          </div>
          <div className='cell-right'>
            <p className='bucket-publish '>{ status } </p>
            <p className='bucket-id'>{ `${shortId}` } </p>
          </div>
        </div>
        <div className={`drop-icon${isArchived ? ' archived' : ''}`}>
          <ButtonContainer displayTitle='Add Bucket' childComponent={<DropIcon onClick={onBucketAdd} isEnabled={isEnabled} />} />
        </div>
      </div>
    )
  }
}

BucketListCell.propTypes = {
  /** Bucket status type of BucketListCell. */
  status: PropTypes.string,
  /** Bucket id of BucketListCell. */
  bucketId: PropTypes.string,
  /** Bucket Name type of BucketListCell. */
  bucketName: PropTypes.string,
  /** Bucket type of BucketListCell. */
  bucketType: PropTypes.string,
  /** Function to be called on bucket add */
  onBucketAdd: PropTypes.func,
  /** Boolean for enable adding to bucket */
  isEnabled: PropTypes.bool,
  /** Boolean to indicate bucket is archived or not */
  isArchived: PropTypes.bool
}

BucketListCell.defaultProps = {
  isSelected: false
}

export default BucketListCell
